import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-facebook"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z","strokeWidth":"props.strokeWidth"}}]}]};

const LogoFacebook = Vue.extend<IconProps>({
  name: 'LogoFacebookIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-facebook',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoFacebook;
